"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _UpsellBreakdown = _interopRequireDefault(require("../../Upsell/UpsellBreakdown"));
var _RecommendationBusinessSolutionTabs = _interopRequireDefault(require("./RecommendationBusinessSolutionTabs"));
var _useRecommendationBusinessSolutions = require("../../../hooks/recommendation/useRecommendationBusinessSolutions");
var _UpsellBreakdownWrapper = _interopRequireDefault(require("../../Upsell/UpsellBreakdownWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RecommendationBusinessSolution = function RecommendationBusinessSolution() {
  var _useRecommendationBus = (0, _useRecommendationBusinessSolutions.useRecommendationBusinessSolutions)(),
    recommendedBusinessSolution = _useRecommendationBus.recommendedBusinessSolution,
    premiumBusinessSolution = _useRecommendationBus.premiumBusinessSolution,
    budgetBusinessSolution = _useRecommendationBus.budgetBusinessSolution,
    alternativeBudgetBusinessSolution = _useRecommendationBus.alternativeBudgetBusinessSolution,
    alternativePremiumBusinessSolution = _useRecommendationBus.alternativePremiumBusinessSolution,
    selectedBusinessSolution = _useRecommendationBus.selectedBusinessSolution;
  var businessSolutions = [recommendedBusinessSolution, premiumBusinessSolution, budgetBusinessSolution, alternativeBudgetBusinessSolution, alternativePremiumBusinessSolution].filter(function (businessSolution) {
    return businessSolution;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RecommendationBusinessSolutionTabs.default, {
    businessSolutions: businessSolutions,
    selectedBusinessSolution: selectedBusinessSolution
  }), /*#__PURE__*/_react.default.createElement(_UpsellBreakdownWrapper.default, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, null, /*#__PURE__*/_react.default.createElement(_UpsellBreakdown.default, null)))));
};
var _default = RecommendationBusinessSolution;
exports.default = _default;